import React, { Component } from "react";
import { inject, observer } from "mobx-react";
import { debounce, isString } from "lodash";
import { Select, Tag } from "antd";

import {
	AutoComplete,
	Col,
	Form,
	Input,
	InputNumber,
	Radio,
	Row,
	Tooltip,
	Typography,
} from "antd";
import { formLayout, formRules } from "../../../../../utilities";
import WizardFormButtons from "../../../../ui/forms/WizardFormButtons";
import PropTypes from "prop-types";
import { toJS } from "mobx";
import { ConsoleSqlOutlined } from "@ant-design/icons";

/**
 * Page from the form wizard with property questions.
 */

const options = [

{ value: "Rock Climbing", label: "Rock Climbing" },
{ value: "Indoor Climbing", label: "Indoor Climbing" },
{ value: "Abseiling", label: "Abseiling" },
{ value: "Bouldering", label: "Bouldering" },
{ value: "Ghyll Scrambling", label: "Ghyll Scrambling" },
{ value: "Coastering", label: "Coastering" },
{ value: "Gorge Walking", label: "Gorge Walking" },
{ value: "Canyoning", label: "Canyoning" },
{ value: "Caving", label: "Caving" },
{ value: "Running", label: "Running" },
{ value: "Trail Running", label: "Trail Running" },
{ value: "Fell Running", label: "Fell Running" },
{ value: "Canoeing", label: "Canoeing" },
{ value: "Kayaking", label: "Kayaking" },
{ value: "Stand up Paddleboarding", label: "Stand up Paddleboarding" },
{ value: "Improvised Raft Building", label: "Improvised Raft Building" },
{ value: "Bell Boating", label: "Bell Boating" },
{ value: "Dinghy Sailing", label: "Dinghy Sailing" },
{ value: "Rowing", label: "Rowing" },
{ value: "Duke of Edinburgh", label: "Duke of Edinburgh" },
{ value: "Lowland Walking", label: "Lowland Walking" },
{ value: "Mountaineering", label: "Mountaineering" },
{ value: "Hiking", label: "Hiking" },
{ value: "Hill Walking", label: "Hill Walking" },
{ value: "Orienteering", label: "Orienteering" },
{ value: "Nordic Walking", label: "Nordic Walking" },
{ value: "Navigation", label: "Navigation" },
{ value: "Map Reading", label: "Map Reading" },
{ value: "Camping / Wild Camping", label: "Camping / Wild Camping" },
{ value: "Forest School", label: "Forest School" },
{ value: "Bushcraft", label: "Bushcraft" },
{ value: "Survival Skills", label: "Survival Skills" },
{ value: "Foraging", label: "Foraging" },
{ value: "Team Building", label: "Team Building" },
{ value: "Swimming", label: "Swimming" },
{ value: "Open Water Swimming", label: "Open Water Swimming" },
{ value: "Archery", label: "Archery" },
{ value: "Air Rifle Shooting", label: "Air Rifle Shooting" },
{ value: "Clay Pidgeon Shooting", label: "Clay Pidgeon Shooting" },
{ value: "Laser Clay Shooting", label: "Laser Clay Shooting" },
{ value: "Slacklining", label: "Slacklining" },
{ value: "Fishing", label: "Fishing" },
{ value: "Cycling", label: "Cycling" },
{ value: "Problem Solving", label: "Problem Solving" },
{ value: "Walking", label: "Walking" },
{ value: "Arts & Crafts", label: "Arts & Crafts" },
{ value: "Community Garden Project", label: "Community Garden Project" },
{ value: "Moikky", label: "Moikky" },
{ value: "Pottery", label: "Pottery" },
{ value: "Scandinavian / Karelian / Finnish Skittles", label: "Scandinavian / Karelian / Finnish Skittles" },
{ value: "John Muir Award", label: "John Muir Award" },
{ value: "Scavenger Hunt (on Foot)", label: "Scavenger Hunt (on Foot)" },
{ value: "Ballet", label: "Ballet" },
{ value: "Barre Balance", label: "Barre Balance" },
{ value: "Dance", label: "Dance" },
{ value: "Gymnastics", label: "Gymnastics" },
{ value: "Meditation", label: "Meditation" },
{ value: "Stretching", label: "Stretching" },
{ value: "Mindfulness Activities", label: "Mindfulness Activities" },
{ value: "Pilates", label: "Pilates" },
{ value: "Reiki", label: "Reiki" },
{ value: "Yoga ", label: "Yoga " },
{ value: "Hot Yoga", label: "Hot Yoga" },
{ value: "Basketball", label: "Basketball" },
{ value: "Bowling", label: "Bowling" },
{ value: "Cricket", label: "Cricket" },
{ value: "English 9 pin", label: "English 9 pin" },
{ value: "Bowls", label: "Bowls" },
{ value: "Football - Golf", label: "Football - Golf" },
{ value: "Frisbee - Golf", label: "Frisbee - Golf" },
{ value: "Gorodki", label: "Gorodki" },
{ value: "Hockey", label: "Hockey" },
{ value: "Quidditch - (simulated)", label: "Quidditch - (simulated)" },
{ value: "Touch Rugby", label: "Touch Rugby" },
{ value: "Skittles", label: "Skittles" },
{ value: "Snooker", label: "Snooker" },
{ value: "Pool", label: "Pool" },
{ value: "Darts", label: "Darts" },
{ value: "Ten Pin", label: "Ten Pin" },
{ value: "Tennis", label: "Tennis" },
{ value: "Football (inc 5-a-side)", label: "Football (inc 5-a-side)" },
{ value: "Golf", label: "Golf" },
{ value: "Beachcombing", label: "Beachcombing" },
{ value: "Metal Detecting (guided)", label: "Metal Detecting (guided)" },
{ value: "Bird Song / Watching - Field Courses", label: "Bird Song / Watching - Field Courses" },
{ value: "City Walking", label: "City Walking" },
{ value: "Kite Flying", label: "Kite Flying" },
{ value: "Boxercise", label: "Boxercise" },
{ value: "Karate", label: "Karate" },
{ value: "Kick Boxing", label: "Kick Boxing" },
{ value: "Wrestling – Elbow", label: "Wrestling – Elbow" },
{ value: "CrossFit", label: "CrossFit" },
{ value: "Spinning", label: "Spinning" },
{ value: "Military Training (imitation) ", label: "Military Training (imitation) " },
{ value: "Personal Training", label: "Personal Training" },
{ value: "Gym Instruction", label: "Gym Instruction" },

];


@inject("context")
@observer
class PropertyQuestions extends Component {
	constructor(props) {
		super(props);
		this.state = { checked: false };
	}

	//		this.state = {
	//			activityTrades: [],
	//		};

	formRef = React.createRef();
	static propTypes = {
		service: PropTypes.object.isRequired,
	};

	onChange = (e) => {
		this.setState({ checked: e.target.checked });
		const organisationAddress = toJS(
			this.props.service.clientData.organisation.address
		);
		if (e.target.checked) {
			this.formRef.current.setFieldsValue({
				riskaddress1: organisationAddress.address1,
				riskaddress2: organisationAddress.address2,
				riskcity: organisationAddress.city,
				riskpostcode: organisationAddress.post_code,
			});
		} else {
			this.formRef.current.setFieldsValue({
				riskaddress1: "",
				riskaddress2: "",
				riskcity: "",
				riskpostcode: "",
			});
		}
	};

	render() {
		const { postcodeLookupService } = this.props.context;
		let postcodeAutocompleteOptions;
		const { isViewMode } = this.props.context.policiesService;
		if (!!postcodeLookupService.postcodeData.addresses) {
			postcodeAutocompleteOptions = postcodeLookupService.postcodeData.addresses.map(
				(addr, index) => {
					let address = addr.formatted_address.filter((el) => !!el).join(", ");
					return {
						label: address,
						value: index.toString(),
					};
				}
			);
		}

		//		const handleActivities = (value) => {
		//			this.setState({ activityTrades: value });
		//		};

		const { clientData } = this.props.service;

		return (
			<Form
				{...formLayout}
				onFinish={this.props.onFinish}
				colon={false}
				ref={this.formRef}
				key={clientData.quoteId}
				initialValues={{
					pl_turnover: clientData.pl_turnover,
					pl_cover_amt: clientData.pl_cover_amt,
					el: clientData.el,
					el_wageroll: clientData.el_wageroll,
					el_volunteer_staff: clientData.el_volunteer_staff,
					equipment: clientData.equipment,
					equipment_cover_amt: clientData.equipment_cover_amt,
					activityTrades: clientData.activityTrades,
				}}
			>
				<Row>
					<Col md={{ span: 16 }}>
						<Form.Item

							name="activityTrades"
							label="Activities"
							rules={[formRules.required]}
						>
							<Select
								mode="tags"
								style={{
									width: "100%",
								}}
								placeholder="Please select activity trades"
								options={options}
								disabled={isViewMode}
							/>
						</Form.Item>
					</Col>
				</Row>
				<Row>
					<Col md={{ span: 16 }}>
						<Form.Item
							name="pl_cover_amt"
							label="What level of PL cover do you require?"
							rules={[formRules.required]}
						>
							<Radio.Group disabled={isViewMode}>
								<Radio value={2}>2m</Radio>
								<Radio value={5}>5m</Radio>
								<Radio value={10}>10m</Radio>
							</Radio.Group>
						</Form.Item>
					</Col>
				</Row>
				<Row>
					<Col md={{ span: 16 }}>
						<Form.Item
							name="pl_turnover"
							label="Annual Turnover"
							rules={[formRules.required, formRules.number]}
						>
							<InputNumber disabled={isViewMode} min={1000} max={50000} placeholder="Turnover" />
						</Form.Item>
					</Col>
				</Row>
				<Row>
					<Col md={{ span: 16 }}>
						<Form.Item
							name="el"
							label="Do you require EL Insurance?"
							rules={[formRules.required]}
						>
							<Radio.Group disabled={isViewMode}>
								<Radio value={true}>Yes</Radio>
								<Radio value={false}>No</Radio>
							</Radio.Group>
						</Form.Item>
					</Col>
				</Row>
				<Row>
					<Col md={{ span: 16 }}>
						<Form.Item
							name="el_wageroll"
							label="Annual Wageroll"
							rules={[formRules.number]}
						>
							<InputNumber disabled={isViewMode} min={0} max={30000} placeholder="Wageroll" />
						</Form.Item>
					</Col>
				</Row>
				<Row>
					<Col md={{ span: 16 }}>
						<Form.Item
							name="el_volunteer_staff"
							label="Are any of your staff Volunteers?"
							rules={[formRules.required]}
						>
							<Radio.Group disabled={isViewMode}>
								<Radio value={true}>Yes</Radio>
								<Radio value={false}>No</Radio>
							</Radio.Group>
						</Form.Item>
					</Col>
				</Row>
				<Row>
					<Col md={{ span: 16 }}>
						<Form.Item

							name="equipment"
							label="Do you require Equipment Cover?"
							rules={[formRules.required]}
						>
							<Radio.Group disabled={isViewMode}>
								<Radio value={true}>Yes</Radio>
								<Radio value={false}>No</Radio>
							</Radio.Group>
						</Form.Item>
					</Col>
				</Row>
				<Row>
					<Col md={{ span: 16 }}>
						<Form.Item
							name="equipment_cover_amt"
							label="Equipment Cover Amount"
							rules={[formRules.number]}
						>
							<InputNumber disabled={isViewMode} min={0} max={20000} placeholder="Equipment Value" />
						</Form.Item>
					</Col>
				</Row>
				<Row>
					<Col xs={24} className="d-flex">
						<WizardFormButtons tabs={this.props.tabs} />
					</Col>
				</Row>
			</Form>
		);
	}

	onClientDataChange = (key, val) => {
		this.formRef.changeCurrentClientData(key, val);
	};

	handleAutocompleteAddressSelected = (value) => {
		const { resetFields, setFieldsValue } = this.formRef.current;
		const { postcodeLookupService } = this.props.context;
		const address = postcodeLookupService.postcodeData.addresses[value];

		resetFields(["riskcity", "riskaddress1", "riskaddress2", "riskpostcode"]);

		const address2 = [
			address.building_name,
			address.building_number,
			address.thoroughfare,
		]
			.filter((el) => !!el)
			.join(", ");

		setFieldsValue({
			riskcity: address.town_or_city,
			riskaddress1: address2,
			riskaddress2: address.county,
			riskpostcode: postcodeLookupService.postcodeData.postcode,
		});
	};

	handleAutocompleteSearch = debounce((value) => {
		const { postcodeLookupService } = this.props.context;

		if (
			isString(value) &&
			isString(postcodeLookupService.postcodeData.postcode) &&
			value.trim().toLowerCase() !==
			postcodeLookupService.postcodeData.postcode.toLowerCase()
		) {
			postcodeLookupService.setPostcodeData({});
		}

		postcodeLookupService.loadPostcodeData(value);
	}, 250);
}

export default PropertyQuestions;
